const tableRowSize = Object.freeze({
  Large: "Large",
  Medium: "Medium",
  Small: "Small",
});

export default tableRowSize;
